"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZLeaderboardDraw = exports.ZDrawEntry = exports.ZGetDrawResults = exports.ZDrawAndPrizeResult = exports.ZDrawResult = exports.ZDrawSelectAdmin = exports.ZDrawSelect = exports.ZDrawScheduleSelectAdmin = exports.ZDrawScheduleSelect = exports.ZDrawTypePlanSelect = exports.ZDrawTypeSelect = void 0;
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const zod_1 = require("zod");
const zodSchemas_generated_1 = require("../../generated/zodSchemas.generated");
const prize_1 = require("../../prize");
exports.ZDrawTypeSelect = zodSchemas_generated_1.zodSelectDrawType
    .pick({
    code: true,
    name: true,
    gameType: true,
    group: true,
})
    .extend({
    numberSetup: dbJsonModels_1.ZDrawTypeNumberSetup.nullable(),
});
exports.ZDrawTypePlanSelect = zodSchemas_generated_1.zodSelectDrawTypePlan
    .pick({
    id: true,
    drawTypeCode: true,
    code: true,
    subcode: true,
    name: true,
    desc: true,
    priceVersion: true,
})
    .extend({
    priceTable: zod_1.z.record(zod_1.z.string(), zod_1.z.record(zod_1.z.string(), zod_1.z.record(zod_1.z.string(), zod_1.z.number()))),
});
exports.ZDrawScheduleSelect = zodSchemas_generated_1.zodSelectDrawSchedule.pick({
    id: true,
    templateName: true,
    description: true,
    code: true,
    drawTypeCode: true,
    prizeStructureId: true,
});
exports.ZDrawScheduleSelectAdmin = zodSchemas_generated_1.zodSelectDrawSchedule.pick({
    id: true,
    templateName: true,
    description: true,
    code: true,
    drawTypeCode: true,
    prizeStructureId: true,
    verificationScheme: true,
    autoRun: true,
});
exports.ZDrawSelect = zodSchemas_generated_1.zodSelectDraw
    .pick({
    id: true,
    name: true,
    description: true,
    status: true,
})
    .extend({
    drawDate: zod_1.z.coerce.date().nullable(),
    pendingResult: zod_1.z
        .optional(zod_1.z.record(zod_1.z.string(), dbJsonModels_1.ZDrawTypeFullResult))
        .nullable(),
    result: zod_1.z.optional(dbJsonModels_1.ZDrawTypeFullResult).nullable(),
});
exports.ZDrawSelectAdmin = zodSchemas_generated_1.zodSelectDraw
    .pick({
    id: true,
    name: true,
    description: true,
    status: true,
    pendingResult: true,
    verified: true,
    winnersNotified: true,
    participantsNotified: true,
    prizesAwardedAt: true,
})
    .extend({
    drawDate: zod_1.z.coerce.date().nullable(),
    pendingResult: zod_1.z
        .optional(zod_1.z.record(zod_1.z.string(), dbJsonModels_1.ZDrawTypeFullResult))
        .nullable(),
    result: zod_1.z.optional(dbJsonModels_1.ZDrawTypeFullResult).nullable(),
    simulatedWinners: zod_1.z.optional(dbJsonModels_1.ZSimulatedWinners).nullable(),
    prizesAwardedAt: zod_1.z.coerce.date().nullable(),
});
exports.ZDrawResult = zod_1.z.object({
    draw: exports.ZDrawSelect,
    drawSchedule: exports.ZDrawScheduleSelect,
});
exports.ZDrawAndPrizeResult = zod_1.z.object({
    draw: exports.ZDrawSelect,
    drawSchedule: exports.ZDrawScheduleSelect,
    prize: prize_1.ZPrizeSelect,
});
exports.ZGetDrawResults = zod_1.z.object({
    drawResults: zod_1.z.array(exports.ZDrawResult),
    drawInProgress: zod_1.z.boolean(),
});
exports.ZDrawEntry = zod_1.z.object({
    id: zod_1.z.string(),
    numbers: dbJsonModels_1.ZEntryLine,
    drawResult: dbJsonModels_1.ZDrawTypeFullResult.nullable(),
    drawTypeCode: zod_1.z.string(),
    drawTypePlanCode: zod_1.z.string(),
    prizeTierCode: zod_1.z.string().nullable().optional(),
    prizeTierId: zod_1.z.number().nullable().optional(),
    prizeStructureId: zod_1.z.number().nullable().optional(),
    prizeChoice: zod_1.z.number().nullable().optional(),
    prizeWinStatus: zod_1.z.string().nullable().optional(),
    prizeValue: zod_1.z.number().nullable().optional(),
    isHypotheticalPrize: zod_1.z.boolean().optional(),
});
exports.ZLeaderboardDraw = exports.ZDrawSelect.extend({});
//# sourceMappingURL=models.js.map